module.exports = __webpack_public_path__ + "img/timetable-empty.e3a41b7b.svg";